import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AuraChatSendRequest {
  message: string;
  newConversation?: boolean;
}

/**
 * Bridges routed feature components (e.g. insight cards) to the Aura chat panel
 * hosted in the app root. Features call {@link send}; the app root listens on
 * {@link requests$}, opens the panel and forwards the message to the runtime.
 */
@Injectable({ providedIn: 'root' })
export class AuraChatBridgeService {
  private readonly requests = new Subject<AuraChatSendRequest>();

  /** Stream of send requests raised by feature components. */
  public readonly requests$ = this.requests.asObservable();

  /** Ask the Aura panel to send a message (opening the panel if needed). */
  public send(request: AuraChatSendRequest): void {
    this.requests.next(request);
  }
}
